<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <p class="plan_item_title">
      <span style="color: #fbfb06"> 曾道人六合心水</span> 家野4.肖
    </p>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <span class="qi">{{ el.qiShu }}期:</span>
        <div :class="{}">
          【 <span style="color: #82007f">家肖:</span>
          <span
            v-for="(e, i) in el.yuCe.jia"
            :key="e"
            :class="{ win: el.shengXiao === e }"
            >{{ e }}</span
          >
          &nbsp <span style="color: #82007f">野肖:</span
          ><span
            style="margin-right: 10px"
            :class="{ win: el.shengXiao === e }"
            v-for="(e, i) in el.yuCe.ye"
            :key="e"
            >{{ e }}</span
          >
          】
          <span style="color: #000">
            开:
            <span style="color: #101010"
              >{{ el.shengXiao || "??" }}{{ el.code || "??" }}</span
            >
            <span style="color: red">{{ el.ifWin ? "准" : "错" }}</span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const origin = window.location.origin;

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);

data.value.list.forEach((item, index) => {
  if (!item.ifZuiXin) {
    data.value.list[index].codeList = item.shuXingList.jia;
    data.value.list[index].yeList = item.shuXingList.ye;
  }
});
console.log(data.value, "data.value");
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    text-align: center;
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    background: #81007f;
    color: #0def12;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 5px 12px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      border-bottom: 1px solid #ccc;
      grid-gap: 10px;
      > div {
        display: flex;
        align-items: flex-end;
        color: red;
      }
      .win {
        background: #fffe03;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>